import { render, staticRenderFns } from "./regionalScreen.vue?vue&type=template&id=70160a90&"
import script from "./regionalScreen.vue?vue&type=script&lang=js&"
export * from "./regionalScreen.vue?vue&type=script&lang=js&"
import style0 from "./regionalScreen.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/root/deploy/iot-gov-report/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('70160a90')) {
      api.createRecord('70160a90', component.options)
    } else {
      api.reload('70160a90', component.options)
    }
    module.hot.accept("./regionalScreen.vue?vue&type=template&id=70160a90&", function () {
      api.rerender('70160a90', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/gov/regionalScreen.vue"
export default component.exports